export default "__VITE_ASSET__9ce53c24__"